<template>
  <div class="wrapper">
    <div class="name-select">
      <div class="name">城市频道</div>
      <div class="select">
        <div class="s-item" :class="currentSelect==v?'act':''" v-for="(v,i) in selectList" :key="i" @mouseenter="select(v)">
          {{ v }}
        </div>
      </div>
    </div>
    <div class="content">
      <div class="tip" v-if="cityList.length < 1">暂无城市</div>
      <div class="main" v-else>
        <div class="cm-item" v-for="(v,i) in cityList" :key="i" @click="citySelect(v)">{{ v.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import {setCity} from "@/utils/locate";

export default {
  name: "City",
  data() {
    return {
      selectList: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K', 'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V', 'W', 'X', 'Y', 'Z'],
      currentSelect: 'A',
      cityList: []
    }
  },
  created() {
    this.getCityList(this.currentSelect)
  },
  methods: {
    /**
     * 城市选定
     * @param city
     */
    citySelect(city) {
      setCity(city)
      location.reload()
    },
    /**
     * 选择
     * @param current
     */
    select(current) {
      this.currentSelect = current
      this.getCityList(current)
    },
    /**
     * 获取城市列表
     * @param initEn
     */
    getCityList(initEn) {
      this.$request.get('/Home/city', {
        params: {
          initEn
        }
      }).then(res => {
        if (res.code === 0) {
          this.cityList = res.data
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.wrapper {
  width: 100%;
  background-color: #FFFFFF;
  border-radius: 8px;

  .name-select {
    height: 40px;
    display: flex;
    flex-direction: row;
    border-bottom: 1px solid #DCDCDC;

    .name {
      width: 204px;
      height: 100%;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      color: #2D2D2D;
      font-size: 16px;
      font-weight: bold;
      border-right: 1px solid #DCDCDC;
    }

    .select {
      flex: 1;
      width: 0;
      display: flex;
      flex-direction: row;
      align-items: center;

      .s-item {
        width: calc(100% / 26);
        border-right: 1px solid #DCDCDC;
        height: 100%;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        color: #6C6C6C;
        font-size: 16px;
        cursor: pointer;

        &.act {
          background-color: #1464FF;
          color: #FFFFFF;
        }

        &:last-child {
          border-right: 0;
        }
      }
    }
  }

  .content {
    padding: 20px;

    .tip {
      width: 100%;
      text-align: center;
      color: #6C6C6C;
      font-size: 14px;
    }

    .main {
      display: grid;
      grid-template-columns: repeat(7, 1fr);
      gap: 10px;

      .cm-item {
        color: #6C6C6C;
        font-size: 14px;
        cursor: pointer;
        text-align: center;

        &:hover {
          color: #1464FF;
        }
      }
    }
  }
}
</style>